import { TAuthResponse, TSrpLoginParams } from "franken-srp";

const STORAGE_KEY = "smart-auth";
const storageKey = (username: string) => [STORAGE_KEY, username].join(".");

type TDevice = Omit<
  Required<Required<TAuthResponse>["newDevice"]>,
  "deviceAutoConfirmed" | "deviceAutoRemembered" | "userConfirmationNecessary"
>;
const isDevice = (d: any): d is TDevice =>
  typeof d === "object" &&
  typeof d.key === "string" &&
  typeof d.groupKey === "string" &&
  typeof d.password === "string";

export const getDevice = (username: string): TSrpLoginParams["device"] => {
  const item = localStorage.getItem(storageKey(username));
  if (item) {
    try {
      const parsed = JSON.parse(item);
      if (isDevice(parsed)) {
        return parsed;
      }
    } catch (e) {
      console.error("Unable to get device", e);
    }
  }
  return undefined;
};

export const setDevice = (username: string, device: TDevice) => {
  localStorage.setItem(storageKey(username), JSON.stringify(device));
};
